'use strict';

import md5 from 'md5'
import diff from "deep-diff";

export default {
  /**
   * * 根据用户信息和请求信息生成验证串
   * @param method 请求的 HTTP Method
   * @param uri 请求的 URI
   * @param dataLength 请求 Body 的长度
   * @returns {string} 验证串
   * @param username 用户名
   * @param password 密码
   * @param department 部门
   * @param role 角色
   * @returns {string} 验证串
   */
  token(method, uri, dataLength, username, password, department, role) {
    const ts = new Date().getTime();
    const message = [method.toLowerCase(), uri, dataLength, password].join('#');
    const sign = md5(message);
    const client = [username, department, role].join('#');
    const base64Client = window.btoa(client);
    const tok = [sign, ts, base64Client].join(':');

    // console.log("in token");

    // console.log("===============");
    // console.log("message:", message);
    // console.log("method:", method.toLowerCase());
    // console.log("uri:", uri);
    // console.log("dataLength:", dataLength);
    // console.log("username:", username);
    // console.log("password", password);
    // console.log("md5:", sign);
    //
    // console.log("ts:", ts);
    // console.log("sign:", sign);
    // console.log("client", client);
    // console.log("base64Client", base64Client);
    //
    // console.log("tok:", tok);
    return tok;
  },

  timestamp: (tms) => tms && tms.slice(0, -5).replace('T', ' '),
  today: () => new Date().toISOString().substring(0, 10),

  range(start, end) {
    return new Array(end - start).fill(start).map((el, i) => start + i);
  },
  clone(obj, keys) {
    let o = {};
    if (keys && Array.isArray(keys)) {
      keys.map(k => o[k] = obj[k]);
    } else {
      o = obj;
    }
    return JSON.parse(JSON.stringify(o));
  },
  changes(objDefault, obj) {
    const differences = diff(objDefault, obj, (path) => path.length > 3);

    let objChanges = {};
    if (differences) {
      // 过滤出修改过的字段
      const fields = differences.filter(
        el => ['N', 'E', 'A'].indexOf(el.kind) >= 0
      ).map(
        el => el.path[0]
      ).filter( // 删除重复的字段名
        (item, index, self) => self.indexOf(item) === index
      );

      fields.forEach(f => objChanges[f] = obj[f]);
    }
    return objChanges;
  },
  paramsPagination(p) {
    let params = {};
    if (p.sortBy) {
      if (p.sortBy.endsWith('.asc') || p.sortBy.endsWith('.desc')) {
        params.sort = p.sortBy
      } else {
        params.sort = p.sortBy + (p.descending ? '.desc' : '.asc')
      }
    }
    if (p.page) {
      params.page = p.page - 1
    }
    if (p.rowsPerPage) {
      params.limit = p.rowsPerPage
    }
    return params;
  },
  paramsFilters(obj) {
    let params = {};
    Object.keys(obj).forEach(
      k => {
        if (obj[k]) {
          const val = obj[k].trim();
          if (val.length > 0) {
            params[k] = val;
          }
        }
      }
    );
    return params;
  },
  param(key, value) {
    let param = {};
    if (value) {
      const val = value.trim();
      if (val.length > 0) {
        param[key] = val;
      }
    }
    return param;
  },
  toApiQuery(qry) {
    const paginationKeys = ['page', 'rowsPerPage', 'sortBy', 'descending', 'totalItems'];
    const queryKeys = Object.keys(qry).filter(k => paginationKeys.indexOf(k) < 0);

    const query = {};
    queryKeys.forEach(k => {
      if (qry[k]) {
        if (Array.isArray(qry[k])) {
          query[k] = qry[k].map(it => it.toString()).join(",")
        }
        else if (typeof qry[k] === 'string') {
          const v = qry[k].trim();
          if (v.length > 0) query[k] = v;
        }
        else if (qry[k] !== undefined || qry[k] !== null) {
          query[k] = qry[k]
        }
      }
    });


    if (!!qry['page']) {
      query['page'] = qry['page'] - 1;
    }

    if (!!qry['rowsPerPage']) {
      query['limit'] = qry['rowsPerPage'];
    }

    if (!!qry['sortBy']) {
      const dir = qry['descending'] === true ? '.desc' : '.asc';
      query['sort'] = qry['sortBy'] + dir;
    }
    return query;
  },

  /**
   * 日期格式验证
   */
  regexpDate() {
    return /^([0-9]{4}-((0[13-9]|1[012])-(0[1-9]|[12][0-9]|30)|(0[13578]|1[02])-31|02-(0[1-9]|1[0-9]|2[0-8]))|([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00)-02-29)$/g
  },
};



// WEBPACK FOOTER //
// ./src/utils/index.js